import {
  GET_ADMIN_CONVERSATIONS_REQUEST,
  GET_ADMIN_CONVERSATIONS_SUCCESS,
  GET_ADMIN_CONVERSATIONS_FAILURE,
} from '../actions/conversationsActions';

const initialState = {
  conversations: [],
  loading: false,
  error: null,
  summary: null,
  pagination: {
    page: 1,
    limit: 20,
    totalCount: 0,
    totalPages: 0,
    currentPage: 1,
    hasNextPage: false,
    hasPrevPage: false,
  },
};

const adminConversationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_CONVERSATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ADMIN_CONVERSATIONS_SUCCESS: {
      const conversations = action.payload?.data?.conversations || [];
      const paginationData = action.payload?.data?.pagination || {};
      const summaryData = action.payload?.data?.summary || null;
      
      return {
        ...state,
        loading: false,
        conversations,
        summary: summaryData,
        pagination: {
          page: paginationData.currentPage || 1,
          limit: paginationData.limit || 20,
          totalCount: paginationData.totalCount || 0,
          totalPages: paginationData.totalPages || 0,
          currentPage: paginationData.currentPage || 1,
          hasNextPage: paginationData.hasNextPage || false,
          hasPrevPage: paginationData.hasPrevPage || false,
        },
        error: null,
      };
    }

    case GET_ADMIN_CONVERSATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        conversations: [], // Clear conversations on API failure
        summary: null, // Clear summary on API failure
        pagination: {
          ...state.pagination,
          totalCount: 0,
          totalPages: 0,
          currentPage: 1,
          hasNextPage: false,
          hasPrevPage: false,
        },
      };

    default:
      return state;
  }
};

export default adminConversationsReducer;
